// src/components/activityList3.js
import React, { useEffect, useState, useContext } from "react";
import { getActList, deleteActivity } from "../api";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";
import { format } from "date-fns";

const ActivityList3 = ({ id_c }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null); // { activities, total }
  const [error, setError] = useState(null);
  const [loadingDel, setLoadingDel] = useState(false);

  // Filtros: Fecha (Date) y Máquina (string)
  const [filterDate, setFilterDate] = useState(null);
  const [filterMachine, setFilterMachine] = useState("");

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      if (!id_c) return;
      const result = await getActList(id_c);
      setData(result);
    } catch (err) {
      setError(t("errorLoading") || "Error cargando actividades");
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id_c]);

  const handleDelete = async (id) => {
    if (!window.confirm(t("confirmDelete") || "¿Eliminar esta actividad? Esta acción no se puede deshacer.")) return;
    try {
      setLoadingDel(true);
      await deleteActivity(id_c, id);
      setData((prev) => {
        if (!prev) return prev;
        const filtered = (prev.activities || []).filter((r) => r.id !== id);
        return { activities: filtered, total: filtered.length };
      });
    } catch (err) {
      console.error("❌ Error deleting activity:", err);
      alert(t("deleteError") || "No se pudo eliminar. Revisa la consola del servidor.");
    } finally {
      setLoadingDel(false);
    }
  };

  if (error) return <p>{error}</p>;
  if (!data) return <p>{t("MList1") || "Loading..."}</p>;

  // Helper para mostrar/filtrar como yyyy-MM.dd a partir de "YYYY-MM-DD"
  const toYMDdot = (s) => (s ? `${s.slice(0, 7)}.${s.slice(8, 10)}` : "");

  // Normaliza filtros
  const fMach = (filterMachine || "").trim().toLowerCase();
  const fDateStr = filterDate ? format(filterDate, "yyyy-MM.dd") : "";

  // Aplica filtros: Fecha exacta y máquina startsWith
  const activities = (data.activities || []).filter((row) => {
    const dateStr = toYMDdot((row.date_act || "").slice(0, 10));
    const machStr = (row.cod_maq || "").toLowerCase();
    const okDate = !fDateStr || dateStr === fDateStr;
    const okMach = machStr.startsWith(fMach);
    return okDate && okMach;
  });

  return (
    <div className="box1">
      <div className="box9">
        <button className="button7" onClick={() => navigate("/new_activity")}>
          {t("actType5") /* “Nueva actividad” */}
        </button>

        {/* Barra de filtros con misma estética */}
        <div className="table5">
          <DatePicker
            selected={filterDate}
            onChange={(d) => setFilterDate(d)}
            dateFormat="yyyy-MM.dd"
            locale={es}
            placeholderText="📅 yyyy-mm.dd"
            className="input1"
            // estilos como en tus listas
            popperPlacement="bottom-start"
            style={{ width: "45%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por máquina"
            value={filterMachine}
            onChange={(e) => setFilterMachine(e.target.value)}
            style={{ width: "45%", float: "left" }}
          />
        </div>

        <table className="table5">
          <thead>
            <tr>
              <th>{t("oper7") /* Fecha */}</th>
              <th>{t("actType2") || "Actividad"}</th>
              <th>{t("batchList2") /* Máquina */}</th>
              <th>{t("batchList3") || "Producto"}</th>
              <th>{t("batchList8") || "Hora Inicio"}</th>
              <th>{t("batchList10") || "Hora Fin"}</th>
              <th>{t("actType4") || "Observaciones"}</th>
              {/* Si agregas acciones, añade más <th> aquí */}
            </tr>
          </thead>
          <tbody>
            {activities.map((row) => (
              <tr key={row.id}>
                <td>{toYMDdot((row.date_act || "").slice(0, 10)) || "-"}</td>
                <td>{row.id_activity}</td>
                <td>{row.cod_maq ?? "-"}</td>
                <td>{row.id_prod ?? "-"}</td>
                <td>{row.time_begin ? row.time_begin.slice(0, 5) : "-"}</td>
                <td>{row.time_end ? row.time_end.slice(0, 5) : "-"}</td>
                <td>{row.observations ?? "-"}</td>

                {/* Ejemplo de acciones por fila (opcional)
                <td>
                  <button className="button" onClick={() => navigate(`/edit_activity/${row.id}`)}>
                    {t("MList7")}
                  </button>
                </td>
                <td>
                  <button className="buttonDel" disabled={loadingDel} onClick={() => handleDelete(row.id)}>
                    {t("general1")}
                  </button>
                </td>
                */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ActivityList3;
